import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/components/pages/home/Index.vue";
import Catalogs from "@/components/pages/Catalogs.vue";
import Error404 from "@/components/pages/Error404.vue";
import CatalogsList from "@/components/pages/CatalogsList.vue";

Vue.use(VueRouter);
const routes = [
  {
    name: "Início",
    path: "/",
    component: Home,
  },
  {
    name: "Catálogos",
    path: "/marcas/:item/catalogos",
    component: Catalogs,
  },
  {
    name: "Catálogos",
    path: "/catalogos",
    component: CatalogsList,
  },
  {
    name: "Erro 404",
    path: "/error404",
    component: Error404,
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/error404");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
